import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import React, { useState, useCallback } from 'react';
import useResourceUsersDropdownOptions from '~/modules/resourcing/common/hooks/useResourceUsersDropdownOptions';
import SearchableUserDropDown from '~/modules/common/components/UserDropdown/SearchableUserDropDown';

export const PreferredResourceUsersDropdown = ({
  value,
  label,
  onChange,
  hasError,
  autoFocus,
  helperText,
  noOptionsText,
  getOptionDisabled,
  getOptionLabel,
  disableClearable,
  inputRef,
  ariaLabel
}) => {
  const { formatMessage } = useIntl();
  const [searchTerm, setSearchTerm] = useState('');

  const handleInputChange = useCallback((_, v) => setSearchTerm(v), []);

  const { hasMore, loading, options } = useResourceUsersDropdownOptions({
    searchTerm: value ? '' : searchTerm
  });

  return (
    <SearchableUserDropDown
      label={label}
      ariaLabel={ariaLabel || formatMessage({ id: 'userDropdown.user' })}
      value={value}
      hasMore={hasMore}
      loading={loading}
      options={options}
      onChange={onChange}
      hasError={hasError}
      helperText={helperText}
      noOptionsText={noOptionsText}
      handleInputChange={handleInputChange}
      autoFocus={autoFocus}
      optionTypeText={formatMessage({ id: 'moreOptions.users' })}
      getOptionDisabled={getOptionDisabled}
      getOptionLabel={getOptionLabel}
      disableClearable={disableClearable}
      inputRef={inputRef}
    />
  );
};

PreferredResourceUsersDropdown.propTypes = {
  label: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  hasError: PropTypes.bool,
  autoFocus: PropTypes.bool,
  helperText: PropTypes.node,
  noOptionsText: PropTypes.node,
  getOptionDisabled: PropTypes.func,
  disableClearable: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  inputRef: PropTypes.object,
  ariaLabel: PropTypes.string
};

export default PreferredResourceUsersDropdown;
